<div data-cy="claim-wizard">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="claim-wizard-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="claim-wizard-header">
      <div class="section-header-title" data-cy="claim-wizard-title">
        Create Claim
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="claim-wizard-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="claim-wizard-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="claim-wizard-loaded-content">

        <!--          body of modal-->
        <div data-cy="claim-wizard-body">
          <div style="display: flex; flex-direction: row" data-cy="claim-wizard-controls">

            <div style="flex-basis: 300px" class="input-container-height" data-cy="claim-wizard-type-container">
              <mat-form-field [style]="'width:250px'" data-cy="claim-wizard-type-field">
                <mat-label data-cy="claim-wizard-type-label">Claim Type</mat-label>
                <mat-select [(ngModel)]="selectedClaimType" (ngModelChange)="claimTypeSelectionChanged()" data-cy="claimwiz-type">
                  <mat-option *ngFor="let type of claimTypes" [value]="type.ValidValueItemId" data-cy="claim-wizard-type-option-{{type.ValidValueItemId}}">
                    {{ type.ItemDisplayValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div style="flex-basis: 350px" class="input-container-height" data-cy="claim-wizard-insurance-container">
              <mat-form-field [style]="'width:350px'" data-cy="claim-wizard-insurance-field">
                <mat-label data-cy="claim-wizard-insurance-label">Claim for ...</mat-label>
                <mat-select [(ngModel)]="selectedInsuranceSelection" (selectionChange)="insuranceSelectionChanged($event)" data-cy="claimwiz-ins-sel">
                  <mat-option *ngFor="let selection of InsuranceSelectionList" [value]="selection.PatientInsuranceID" data-cy="claim-wizard-insurance-option-{{selection.PatientInsuranceID}}">
                    {{ selection.InsuranceName + (selection.PatientInsurancePrimary ? ' | Primary' : '') }} {{ returnPatientInsuranceDateString(selection.PatientInsuranceID) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div style="padding-left: 20px" class="input-container-height" data-cy="claim-wizard-zero-container">
              <mat-checkbox [(ngModel)]="showZeroInsurance" (ngModelChange)="onShowZeroInsurance($event)" data-cy="claim-wizard-zero-checkbox">Include Items With Insurance Estimate = $0.00</mat-checkbox>
            </div>

          </div>
        </div>

        <div class="transaction-list-container" data-cy="claim-wizard-transaction-list">

          <div style="width:100%; padding-right: 15px; background-color: var(--tdo-purple-light);" data-cy="claim-wizard-table-header">
            <div *ngIf="!isPrimarySelected || this.selectedClaimType === ClaimTypeEnum.SecondaryRealClaim" class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="claim-wizard-header-claim-no">Claim No</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="claim-wizard-header-tooth">Tooth</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_35" data-cy="claim-wizard-header-procedure">Procedure</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="claim-wizard-header-fee">Fee Details</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_20" data-cy="claim-wizard-header-doctor">Doctor/Insurance</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_10" data-cy="claim-wizard-header-date">Post Date</div>
            <div class="trans_header_item_cell trans_item_cell_width_pct_5" data-cy="claim-wizard-header-select">
              <mat-checkbox (change)="onClickSelectAll($event)" data-cy="claimwiz-select-all"></mat-checkbox>
            </div>
          </div>

          <div *ngIf="isLoading" data-cy="claim-wizard-loading-bar">
            <mat-progress-bar mode="indeterminate" data-cy="claim-wizard-progress-bar"></mat-progress-bar>
          </div>

          <div *ngIf="!isLoading" class="main-content-container" data-cy="claim-wizard-transactions">

            <!--new list format-->

            <div *ngFor="let dti of dataTransactionItemsByInsurance" data-cy="claim-wizard-insurance-group">

              <div class="trans_item_insurance" *ngIf="dti.PatientInsuranceID != this.emptyGuid" data-cy="claim-wizard-insurance-header">
                {{ dti.InsuranceName }} {{ dti.PatientInsurancePrimary ? '| Primary' : '' }} {{ returnPatientInsuranceDateString(dti.PatientInsuranceID) }}
              </div>

              <div *ngFor="let transactionItem of dti.dataARTransactionItems; let i = index" style="width:100%" [class.offset-item]="i % 2" data-cy="claim-wizard-transaction-item">

                <div *ngIf="!isPrimarySelected || this.selectedClaimType === ClaimTypeEnum.SecondaryRealClaim" class="trans_item trans_item_cell_width_pct_10" data-cy="claim-wizard-item-claim-no">
                  {{ this.getClaimNumber(transactionItem) }}
                </div>

                <div class="trans_item trans_item_cell_width_pct_10" data-cy="claim-wizard-item-tooth">
                  <table style="width:100%" data-cy="claim-wizard-item-tooth-table">
                    <tr data-cy="claim-wizard-item-tooth-row">
                      <td data-cy="claim-wizard-item-tooth-cell">
                        <div class="transaction-detail" data-cy="claim-wizard-item-tooth-value">
                          {{ transactionItem.TeethReference || 'No Tooth Chosen' }}
                        </div>
                      </td>
                      <td style="vertical-align: top; text-align: right; width:24px" data-cy="claim-wizard-item-tooth-edit-cell">
                        <div class="edit-detail-button-container" *ngIf="1==2" data-cy="claim-wizard-item-tooth-edit-container">
                          <i class="material-icons edit-detail-button"
                             (click)="editDetailForTransaction(transactionItem, 'DATA_ENABLE_TOOTH_EDIT')"
                             data-cy="claim-wizard-item-tooth-edit-btn">edit</i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

                <div class="trans_item trans_item_cell_width_pct_35" data-cy="claim-wizard-item-procedure">
                  <table style="width:100%" data-cy="claim-wizard-item-procedure-table">
                    <tr data-cy="claim-wizard-item-procedure-row">
                      <td data-cy="claim-wizard-item-procedure-cell">
                        <div data-cy="claim-wizard-item-procedure-container">
                          <div class="transaction-detail" data-cy="claim-wizard-item-procedure-value">
                            {{ (transactionItem.Code + ' ' + transactionItem.Description) || 'No Procedure Chosen' }}
                          </div>
                        </div>
                      </td>
                      <td style="vertical-align: top; text-align: right; width:24px" data-cy="claim-wizard-item-procedure-edit-cell">
                        <div class="edit-detail-button-container" *ngIf="1==2" data-cy="claim-wizard-item-procedure-edit-container">
                          <i class="material-icons edit-detail-button"
                             (click)="editDetailForTransaction(transactionItem, 'DATA_ENABLE_CODE_EDIT')"
                             data-cy="claim-wizard-item-procedure-edit-btn">edit</i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

                <div class="trans_item  trans_item_cell_width_pct_10" style="vertical-align: top !important;" data-cy="claim-wizard-item-fee">
                  <div *ngIf="!isInsuranceEstimating" data-cy="claim-wizard-item-fee-doctor">
                    {{ transactionItem.DoctorsPrice | currency }}
                  </div>
                  <div *ngIf="isInsuranceEstimating" data-cy="claim-wizard-item-fee-insurance">
                    {{ transactionItem.Price | currency }}
                  </div>
                </div>

                <div class="trans_item  trans_item_cell_width_pct_20" data-cy="claim-wizard-item-doctor">
                  <div data-cy="claim-wizard-item-insurance-name">{{ transactionItem.PatientInsuranceName }}</div>
                  <br/>
                  <div data-cy="claim-wizard-item-doctor-name">{{ this.getDoctorById(transactionItem.ProviderDoctorId) }}</div>
                  <br/>
                  <div data-cy="claim-wizard-item-location">{{ transactionItem.Location }}</div>
                </div>

                <div class="trans_item  trans_item_cell_width_pct_10" data-cy="claim-wizard-item-date">
                  {{ transactionItem.PostDate | date }}
                </div>

                <div class="trans_item  trans_item_cell_width_pct_5" style="text-align: right; padding-right: 20px" data-cy="claim-wizard-item-select">
                  <mat-checkbox [(ngModel)]="transactionItem.isSelected" data-cy="claimwiz-select-item"></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="claim-wizard-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="claim-wizard-footer-spacer"></div>
      <button [disabled]="!returnSelectedCount()" (click)="createClaimForSelectedTransactionItems()" class="tdo-button tdo-save" style="margin-right: 10px;" data-cy="claimwiz-button-create">Create / View</button>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="claimwiz-button-close">Close</button>
    </div>
  </div>
</div>
